import React, { memo, useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardEdu.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftCard = useCallback(() => {
    // 小banner点击
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          cardName: 'SoftCardEdu',
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfo.source || 'SoftCardEdu_Source_Err',
        source_pp: logInfoData.source_p,
      }),
    );

    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  }, [dispatch, logInfo, history]);

  return (
    <div
      className={styles.soft_card}
      onClick={() => {
        handleSoftCard(soft);
      }}
    >
      <div className={styles.soft_info_img_box}>
        <img className={styles.soft_info_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_info_img_logo} />}
      </div>
      <div className={styles.soft_info}>
        <div
          className={styles.soft_name}
          title={(soft.softName && soft.softName.length) > 5 ? soft.softName : ''}
        >
          {soft.softName}
        </div>
        <div
          className={styles.soft_opt}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {soft.androidType === '1' ? (
            <ApkButton
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
              }}
              logInfo={{ ...logInfo }}
            />
          ) : (
            <Button
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
              }}
              logInfo={{ ...logInfo }}
            />
          )}
        </div>
      </div>
    </div>
  );
});
